var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecordingsModalIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.529297,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FFF1DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6177 14.512L13.3466 10.2387C13.0468 10.0625 12.7058 9.96874 12.3581 9.96683C12.0104 9.96492 11.6684 10.055 11.3667 10.2278C11.065 10.4007 10.8144 10.6502 10.6403 10.9512C10.4661 11.2521 10.3746 11.5937 10.375 11.9414V20.4879C10.3743 20.8361 10.4658 21.1783 10.6401 21.4797C10.8145 21.781 11.0655 22.0309 11.3677 22.2038C11.6666 22.3732 12.0037 22.4637 12.3473 22.4668C12.699 22.4655 13.0441 22.3702 13.3466 22.1907L20.6177 17.9174C20.915 17.7436 21.1617 17.495 21.3331 17.1962C21.5045 16.8975 21.5947 16.5591 21.5947 16.2147C21.5947 15.8703 21.5045 15.5319 21.3331 15.2331C21.1617 14.9344 20.915 14.6858 20.6177 14.512Z",
    fill: "#FAA53D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 16.2147V20.488C10.3743 20.8362 10.4658 21.1783 10.6401 21.4797C10.8145 21.7811 11.0655 22.0309 11.3677 22.2039C11.6666 22.3732 12.0037 22.4637 12.3473 22.4668C12.699 22.4656 13.0441 22.3702 13.3466 22.1907L20.6177 17.9175C20.9143 17.7431 21.1601 17.4943 21.3308 17.1956C21.5015 16.8969 21.5911 16.5587 21.5907 16.2147H10.375Z",
    fill: "#FAA53D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingsModalIcon2);
export default __webpack_public_path__ + "static/media/recordings-modal-icon-2.fd7abe6c0c435d5394378c6a89b5ccbd.svg";
export { ForwardRef as ReactComponent };